import { useContactMethods } from './hooks';
import { buildContactFormUrl } from './logics';
import { ContactMethodsPresentation } from './presentations';

/**
 * お問い合わせ手段 Container
 */
export const ContactMethods: React.FC = () => {
  const {
    state: { threeLetterCode },
  } = useContactMethods();

  return <ContactMethodsPresentation contactFormUrl={buildContactFormUrl(threeLetterCode)} />;
};
